import script from "./MitiWhatsapp.vue?vue&type=script&setup=true&lang=js"
export * from "./MitiWhatsapp.vue?vue&type=script&setup=true&lang=js"

import "./MitiWhatsapp.vue?vue&type=style&index=0&id=2f978fa4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f978fa4"]])

export default __exports__